import React from 'react'

type TruckOrderTabIconProps = {
  testId?: string
  isActive?: boolean
}

const exhaustDots = [
  { key: '1', duration: '1s', fromX: '0.25', toX: '-3.25', fromY: '13.5', toY: '7.5' },
  { key: '2', duration: '0.8s', fromX: '-0.25', toX: '-3.75', fromY: '12.75', toY: '7' },
  { key: '3', duration: '0.6s', fromX: '0.75', toX: '-2.75', fromY: '14', toY: '8' },
]

export function TruckOrderTabIcon({ testId, isActive = false }: TruckOrderTabIconProps) {
  return (
    <svg
      width="24"
      height="20"
      viewBox="-3 -2 27 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
      style={{ overflow: 'visible' }}
    >
      {isActive
        ? exhaustDots.map(({ key, duration, fromX, toX, fromY, toY }) => (
            <circle
              key={key}
              data-testid={`order-tab-custom-icon-truck-dot-${key}`}
              cx={fromX}
              cy={fromY}
              r="0"
              fill="currentColor"
            >
              <animate attributeName="r" values="0;2.6" dur={duration} repeatCount="indefinite" />
              <animate
                attributeName="cx"
                values={`${fromX};${toX}`}
                dur={duration}
                repeatCount="indefinite"
              />
              <animate
                attributeName="cy"
                values={`${fromY};${toY}`}
                dur={duration}
                repeatCount="indefinite"
              />
              <animate
                attributeName="opacity"
                values="1;0"
                dur={duration}
                repeatCount="indefinite"
              />
            </circle>
          ))
        : null}
      <g>
        {isActive ? (
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0; 0 -1; 0 0"
            dur="0.2s"
            repeatCount="indefinite"
          />
        ) : null}
        <path
          d="M4.54787 16.406C5.96149 16.406 7.10746 15.2601 7.10746 13.8465C7.10746 12.4328 5.96149 11.2869 4.54787 11.2869C3.13425 11.2869 1.98828 12.4328 1.98828 13.8465C1.98828 15.2601 3.13425 16.406 4.54787 16.406Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M18.3174 16.406C19.731 16.406 20.877 15.2601 20.877 13.8465C20.877 12.4328 19.731 11.2869 18.3174 11.2869C16.9038 11.2869 15.7578 12.4328 15.7578 13.8465C15.7578 15.2601 16.9038 16.406 18.3174 16.406Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M16.2967 0.770996H0.769531V13.0832H16.2967V0.770996Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M23.2285 13.0524H16.6445V4.90332H21.3474L23.2285 13.0524Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M16.9844 8.40356H21.8723"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
